import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { usePeople } from "../hooks/hooks_index";
import { Loading } from "../components/components_index";
import { AuthUserProvider } from "./AuthContext";
import "../styles/RequireAuth.css";

export default function RequireAuth({ children }) {
  const {data: people, isLoading: peopleLoading, error: peopleError} = usePeople();

  const {
    loginWithRedirect,
    isAuthenticated,
    isLoading,
    user,
    logout,
    // getAccessTokenSilently
  } = useAuth0();
  
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) return <Loading/>

  if (!isAuthenticated) {
    return <Loading word="Redirecting to login..." />;
  }

  if (peopleLoading || isLoading) return <Loading/>

  const matchedPerson =
    people && user?.email
      ? Object.entries(people).find(
          ([, person]) =>
            person.email?.toLowerCase().trim() ===
            user.email.toLowerCase().trim()
        )
      : null;

  if (!matchedPerson) {
    return (
      <div className="login-denied">
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h2>Access Denied</h2>
          <p className="auth-text">Your email is not authorized for this site.</p>

          <button className="log-out"
            onClick={() =>
              logout({
                logoutParams: {
                  returnTo: window.location.origin
                }
              })
            }
          >
            Logout
          </button>
        </div>
      </div>
    );
  }

  if (user && user.email_verified === false) {
    return (
      <div className="verify-email">
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h2>Email verification required</h2>

          <p className="auth-text">Please verify your email before continuing:</p>

          <p className="auth-text strong">
            <strong>{user.email}</strong>
          </p>

          <p className="auth-text small">(Check your spam inbox and refresh this page after verifying)</p> 

          <div style={{ marginTop: "2rem" }}>
            <button
              className="log-out"
              onClick={() =>
                logout({
                  logoutParams: {
                    returnTo: window.location.origin
                  }
                })
              }
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (peopleError) return <div>Error</div>;
  if (!people) return <Loading/>

  const [loginID, loginData] = matchedPerson;
  const role = loginData.role ?? "member";

  return (
    <AuthUserProvider
      value={{
        loginID,
        role,
        loginData,
        auth0User: user
      }}
    >
      {children}
    </AuthUserProvider>
  );
}






// import { useEffect, useMemo, useState } from "react";
// import { usePeople } from "../hooks/hooks_index";
// import { AuthUserProvider } from "./AuthContext";
// import "../styles/RequireAuth.css";

// export default function RequireAuth({ children }) {
//   const {
//     data: people,
//     isLoading: peopleLoading,
//     error: peopleError
//   } = usePeople();

//   // DEV ONLY — pretend we're logged in as this person
//   const loginID = "P420000";

//   if (peopleLoading) {
//     return <div>Loading...</div>;
//   }

//   if (peopleError) {
//     return <div>Error loading people.</div>;
//   }

//   if (!people) {
//     return <div>Loading...</div>;
//   }

//   const loginData = people[loginID];

//   if (!loginData) {
//     return (
//       <div style={{ padding: "2rem", textAlign: "center" }}>
//         Development user not found.
//       </div>
//     );
//   }

//   const role = loginData.role ?? "member";

//   return (
//     <AuthUserProvider
//       value={{
//         loginID,
//         role,
//         loginData,
//         auth0User: null
//       }}
//     >
//       {children}
//     </AuthUserProvider>
//   );
// }